import React, { ReactNode, Ref } from 'react';

import { LinkProps as NovaLinkProps, Link as NovaLink } from '@coachhubio/nova-link';
import { default as NextLink, LinkProps as NextLinkProps } from 'next/link';

interface PickedNextLinkProps extends Pick<NextLinkProps, 'as' | 'prefetch' | 'scroll' | 'replace' | 'passHref'> {}

export type LinkProps = PickedNextLinkProps &
  NovaLinkProps & {
    children: ReactNode;
    className?: string;
    innerRef?: () => any;
    onClick?: () => any;
    href?: NextLinkProps['href'];
  };

interface NextComposedProps extends PickedNextLinkProps {
  as?: string;
  children: ReactNode;
  href: string | object;
  prefetch?: boolean;
}

const NextComposed = React.forwardRef((props: NextComposedProps, ref: Ref<any>) => {
  const { as, href, prefetch, scroll, replace, passHref, children, ...rest } = props;

  return (
    <NextLink href={href} as={as} prefetch={prefetch} scroll={scroll} replace={replace} passHref={passHref}>
      <a ref={ref} {...rest}>
        {children}
      </a>
    </NextLink>
  );
});

export function Link({ className, innerRef, ...rest }: LinkProps) {
  const Component = (rest.href ? NextComposed : undefined) as any;
  // @ts-ignore
  return <NovaLink component={Component} ref={innerRef} {...rest} />;
}
